import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Hauteur du header sticky public (aligné sur PublicSiteHeader). */
const HEADER_SCROLL_OFFSET = 96;

function isPublicWebRoute(pathname: string): boolean {
  return (
    pathname === '/' ||
    pathname.startsWith('/filieres') ||
    pathname.startsWith('/legal/') ||
    pathname === '/excellence'
  );
}

function scrollToHashSection(hash: string): (() => void) | undefined {
  const id = hash.replace(/^#/, '').trim();
  if (!id) return undefined;

  const scrollToTarget = () => {
    const el = document.getElementById(id);
    if (!el) return false;
    const top = el.getBoundingClientRect().top + window.scrollY - HEADER_SCROLL_OFFSET;
    window.scrollTo({ top: Math.max(0, top), left: 0, behavior: 'auto' });
    return true;
  };

  if (scrollToTarget()) return undefined;

  const retryShort = window.setTimeout(scrollToTarget, 150);
  const retryLong = window.setTimeout(scrollToTarget, 450);

  return () => {
    window.clearTimeout(retryShort);
    window.clearTimeout(retryLong);
  };
}

/**
 * Remet le scroll en haut lors d’une navigation entre pages publiques.
 * Conserve le comportement des ancres (#filieres, #tarifs, etc.).
 */
export default function PublicScrollRestoration() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!isPublicWebRoute(pathname)) {
      return undefined;
    }

    if (hash) {
      return scrollToHashSection(hash);
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    return undefined;
  }, [pathname, hash]);

  return null;
}
